import React, { Component } from "react";
import { AlertModal } from "../AlertModal/AlertModal";
import './API.css';
import api from "../../services/api";

const Parser = require('html-to-react').Parser;

export const ModalInformacoesTecnicasAPI = 

class extends Component {

  constructor(props){
			super(props);
			this.state = {
				textoOrientacoesGeraisApis: '',
			};

		}

	render() {
		return <AlertModal
          titulo={this.props.titulo}
		      visible={this.props.visible}
          handleClose={this.props.handleClose}
          width={'90%'}
        >
          <div className="container-body" style={{height: '80vh', overflowY: 'auto'}}>
            {Parser().parse(this.state.textoOrientacoesGeraisApis)}
          </div>
        </AlertModal>
	}

  componentDidMount(){
    api.get('/api/aplicacao-fornecedora/texto-orientacoes-gerais-apis')
			.then(response => { 
				this.setState(
					{
						textoOrientacoesGeraisApis: response.data,
					}
				);
			})
			.catch(erro => {
				console.log("Não foi possível recuperar o texto de orientações gerais das APIs: " + JSON.stringify(erro));
				this.props.exibeMensagemErro("Erro durante o carregamento do texto de orientações gerais das API's.")
			});
  }

}